
import { defineComponent } from "vue";
import IArticle from "../../Interface/IArticle";
import Article from "../Generics/Article.vue";

export default defineComponent({
  name: "ArticlesGallery",
  components: { Article },
  data() {
    return {
      articles: [
        {
          address: require("../../assets/img/Articles/money.png"),
          alt: "Money image",
          title: "Receive money in any currency with no fees",
          author: "Claire Robinson",
          description:
            "The world is getting smaller and we’re becoming more mobile. So why should you be forced to only receive money in a single …",
        },
        {
          address: require("../../assets/img/Articles/dinner.png"),
          alt: "Dinner image",
          title: "Treat yourself without worrying about money",
          author: "Wilson Hutton",
          description:
            "Our simple budgeting feature allows you to separate out your spending and set realistic limits each month. That means you …",
        },
        {
          address: require("../../assets/img/Articles/plane.png"),
          alt: "Plane image",
          title: "Take your Easybank card wherever you go",
          author: "Wilson Hutton",
          description:
            "We want you to enjoy your travels. This is why we don’t charge any fees on purchases while you’re abroad. We’ll even show you …",
        },
        {
          address: require("../../assets/img/Articles/live.png"),
          alt: "Live image",
          title: "Our invite-only Beta accounts are now live!",
          author: "Claire Robinson",
          description:
            "After a lot of hard work by the whole team, we’re excited to launch our closed beta. It’s easy to request an invite through the site ...",
        },
      ] as IArticle[],
    };
  },
});
